<template>
  <v-dialog v-model="esVisible" max-width="350" persistent transition="dialog-top-transition">
      <v-card>
          <v-card-title>
              <v-icon color="primary" class="mr-3">mdi-alert</v-icon> Alerta
          </v-card-title>
          <v-card-text>
              {{titulo}}
          </v-card-text>
          <v-card-text class="d-flex justify-end">
              <v-btn @click="confirmar()" class="mr-3 px-8" color="green" dense dark>{{btnConfirmar}}</v-btn>              
              <v-btn @click="cancelar()" class="px-8" color="red" dense dark>{{btnCancelar}}</v-btn>
          </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'DialogoConfirmacion',
    data() {
        return {
            esVisible: false,
            titulo: '',
            btnConfirmar: '',
            btnCancelar: '',

            // Private variables
            resolvePromise: undefined,
            rejectPromise: undefined,
        }
    },

    methods: {
        abrir(opts = {}){
            this.titulo = opts.titulo
            this.btnConfirmar = opts.confirmar
            this.btnCancelar = opts.cancelar

            this.esVisible = true

            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        confirmar(){
            this.resolvePromise(true)
            this.esVisible = false
        },
        cancelar(){
            this.resolvePromise(false)
            this.esVisible = false
        }
    },
}
</script>

<style>

</style>